import { MidFilter } from 'app/model/mid-filter';

export interface FilterData {
    name: string;
    filters: MidFilter[];
}

export const createBlankFilterData = (): FilterData => ({ name: '', filters: [] });
